
import {
  Vue,
  Component,
  Prop,
  Mixins,
} from 'vue-property-decorator';
import {
  Dialog,
  Steps,
  Step,
  Button,
} from 'element-ui';
import { IMatchForm } from '@/types/match.d';
import api from '@/api/match';
import moment from 'moment';
import FormMixin from './formMixin';
import firstStep from './firstStep.vue';
import secondStep from './secondStep.vue';
import thirdStep from './thirdStep.vue';

@Component({
  components: {
    Dialog,
    Button,
    Steps,
    Step,
    firstStep,
    secondStep,
    thirdStep,
  },
})
export default class ManageBusModal extends Vue {
  @Prop({
    required: true,
    default: false,
  }) visible!: boolean;

  @Prop({
    required: false,
    default: '添加赛事',
  }) title!: string;

  @Prop({
    required: false,
  }) oldForm!: any;

  private steps: Array<{ title: string, icon: string }> = [
    {
      title: '基本内容',
      icon: '',
    },
    {
      title: '赛事规则',
      icon: '',
    },
    {
      title: '赛事内容',
      icon: '',
    },
  ];

  private curModalComp: string = 'firstStep';

  private lastLoading: boolean = false;

  private nextLoading: boolean = false;

  public $refs!: {
    stepComp: firstStep | secondStep | thirdStep;
  }

  get stepActive() {
    /* eslint-disable default-case */
    switch (this.curModalComp) {
      case 'firstStep': return 1;
      case 'secondStep': return 2;
      case 'thirdStep': return 3;
    }
    return 1;
  }

  get matchData() {
    return this.oldForm;
  }

  /**
   * @author liangyongmou
   * @desc 点击下一步
   * @param 空
   */
  nextStep() {
    /* eslint-disable default-case */
    switch (this.curModalComp) {
      case 'firstStep': this.handleFirst(); break;
      case 'secondStep': this.handleSecond(); break;
      case 'thirdStep': this.handleThird(); break;
    }
  }

  /**
   * @author iangyongmou
   * @desc 第一步提交
   * @param 空
   */
  handleFirst() {
    const form = this.$refs.stepComp.handleSubmit();
    if (Object.keys(form).length !== 0) {
      const data = new FormData();
      data.append('title', form.title);
      data.append('sponsor', form.sponsor);
      if (typeof form.coverImage !== 'string') data.append('thumbnailPic', form.coverImage);
      if (typeof form.thumbnail !== 'string') data.append('coverPic', form.thumbnail);
      data.append('quality', form.quality);
      data.append('manageTeacher', form.manageTeacher as any);
      data.append('declarationTime', moment(form.declarationTime).format('YYYY-MM-DD HH:mm:ss'));
      data.append('reviewTime', moment(form.reviewTime).format('YYYY-MM-DD HH:mm:ss'));
      data.append('auditTime', moment(form.auditTime).format('YYYY-MM-DD HH:mm:ss'));
      data.append('endTime', moment(form.endTime).format('YYYY-MM-DD HH:mm:ss'));
      data.append('organizer', form.organizer || '');
      data.append('coOrganizer', form.coOrganizer || '');
      data.append('awardNumber', String(form.awardNumber));
      if (this.title.includes('编辑')) {
        data.append('pid', form.pid || '');
        api.editMatch(data).then((res: any) => {
          this.$emit('refrsh');
          this.matchData.pid = res.data;
          this.matchData.quality = form.quality;
          this.curModalComp = 'secondStep';
        /* eslint-disable no-return-assign */
        });
      } else {
        api.addMatch(data).then((res: any) => {
          this.matchData.quality = form.quality;
          this.matchData.pid = res.data;
          this.curModalComp = 'secondStep';
        /* eslint-disable no-return-assign */
        });
      }
    }
  }

  /**
   * @author iangyongmou
   * @desc 第二步提交
   * @param 空
   */
  handleSecond() {
    const form = this.$refs.stepComp.handleSubmit();
    if (Object.keys(form).length !== 0) {
      const groupForm = Object.assign({}, form);
      delete groupForm.list;
      api.addAwards(this.oldForm.pid, form.list).then((res:any) => {
        if (Object.keys(groupForm).length && groupForm.guideTeacherList) {
          api.addGroup(this.oldForm.pid, groupForm).then((result: any) => {
            this.curModalComp = 'thirdStep';
          });
        } else {
          this.curModalComp = 'thirdStep';
        }
      });
    }
  }

  /**
   * @author iangyongmou
   * @desc 第三步提交
   * @param 空
   */
  handleThird() {
    const form = this.$refs.stepComp.handleSubmit();
    if (Object.keys(form).length !== 0) {
      const data = new FormData();
      data.append('pid', form.pid);
      data.append('content', form.content);
      api.editMatchContent(data).then((res: any) => {
        this.$emit('refrsh');
        this.$emit('update:visible', false);
      });
    }
  }

  /**
   * @author liangyongmou
   * @desc 重置表单
   * @param 空
   */
  reset() {
    this.curModalComp = 'firstStep';
    this.$emit('update:visible', false);
  }
}
